export const UPDATE_ATTRIBUTION_DATA:string = 'attribution/UPDATE_ATTRIBUTION_DATA';